import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import Food from "./Food";
import "./index.scss";

@inject('store')
@observer
class App extends Component {
    render() {
        return (
            <div className="daily-s" >
                <Food />
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/index.js